export const watchDetailData = [
  {
    title: 'Material',
    constent: 'Sandblasted titanium'
  },
  {
    title: 'SIZE',
    constent: '42 mm' 
  },
  {
    title: 'THICKNESS',
    constent: '14.6 mm' 
  },
  {
    title: 'WATER RESISTANCE',
    constent: 'Water-resistant to 50 metres' 
  },
  {
    title: 'MECHANISM',
    constent: 'Hand-wound Manufacture Calibre 2965' 
  },
  {
    title: 'CASE DESCRIPTION',
    constent: 'Sandblasted titanium case with titanium inserts, glare proof sapphire crystal and caseback, black ceramic bezel and crown.' 
  },
  {
    title: 'DIAL',
    constent: 'Hand-painted white gold 3D Black Panther character, purple inner bezel, white gold Royal Oak hands with luminescent coating.' 
  },
  {
    title: 'STRAP',
    constent: 'Purple rubber strap with titanium AP folding clasp. Additional black rubber strap.' 
  },
  {
    title: '- HIDE DETAILS',
    constent: '' 
  }
]